import React from 'react';
import { withStyles, Grid, Button } from '@material-ui/core';
import SolidBackdrop from '../misc/SolidBackdrop';
import HeadlineText from '../misc/HeadlineText';
import ArrowButton from '../misc/ArrowButton';
import Link from '../misc/Link';
import theme from '../../theme';
import { trackEvent, trackLink, AnalyticsConstants } from '../../../utilities/analyticsUtilities';
import { getConfigurationProperty } from '../../../configuration';

const styles = theme => ({
    section: {
        position: 'relative',
        [theme.breakpoints.down('sm')]: {
            padding: theme.spacing(2)
		},
        [theme.breakpoints.up('md')]: {
            padding: `${theme.spacing(4) * 1.5}px 0`
        },
        marginTop: 0,
        marginBottom: 0
    },
    pricingButton: {
        marginRight: 'auto',
        marginLeft: 'auto',
        display: 'block',
    }
});

const createAVideoId = 'index-end-section-create-a-video-button'

class IndexEndSection extends React.Component {
	render() {
        const { classes } = this.props;

		return (
            <Grid
                container
                alignItems='center'
                justify='center'
                spacing={8}
                className={classes.section}
                direction='column'
            >
                <SolidBackdrop
                    image='https://specterr.b-cdn.net/bg-wave3.svg'
                    color={theme.palette.background.darker1}
                />
                <Grid item>
                    <HeadlineText align='center'>
                        Get Started For Free
                    </HeadlineText>
                </Grid>
                <Grid item>
                    <ArrowButton
                        href={getConfigurationProperty('CreateVideoEndpoint')}
                        color='primary'
                        variant='contained'
                        size='large'
                        id={createAVideoId}
                    >
                        Create A Video
                    </ArrowButton>
                    <br/>
                    <br/>
                    <Link
                        to='/pricing/'
                        underline='none'
                        onClick={() => {
                            trackEvent('Clicked CTA', {
                                location: 'home examples',
                                destination: 'pricing',
                                color: 'grey',
                                text: 'SEE PRICING',
                                type: 'button',
                                category: AnalyticsConstants.ACQUISITION_CATEGORY
                            });
                        }}
                    >
                        <Button
                            size='large'
                            className={classes.pricingButton}
                        >
                            See Pricing
                        </Button>
                    </Link>
                </Grid>
            </Grid>
		);
    }

    componentDidMount() {
		setTimeout(() => {
			trackLink(createAVideoId, 'Clicked CTA', {
				location: 'home end',
				destination: 'create',
				color: 'red',
				text: 'CREATE A VIDEO',
				type: 'button',
				category: AnalyticsConstants.ACQUISITION_CATEGORY
			});
		}, 100);
	}
}

export default withStyles(styles)(IndexEndSection);